import moment from "moment-jalaali";
import fa from "moment/locale/fa";
moment.locale("fa", fa);
moment.loadPersian({dialect: 'persian-modern'});

// price format
export const priceFormat = (price) => {
  return price ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
};

export const dateFormat = (date , locale = "fa" , format = "jYYYY/jMM/jDD") => {
  return moment.utc(date).locale(locale).format(format); 
}

export const dateFaFormatType1 = (date) => {  
  return moment.utc(date).locale("fa").format("dddd DD jMMMM");  
};
export const dateFaFormatType2 = (date) => {  
  return moment.utc(date).locale("fa").format("jD jMMMM jYYYY");  
};

export const dayFromNow = date => {
  return moment(date).fromNow();
}

